import { cva, type VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const bodyVariants = cva("font-['TT Commons'] tracking-normal", {
  variants: {
    variant: {
      100: "text-base",
      200: "text-sm tracking-[0.28px]",
      300: "text-xs",
      400: "text-xxs leading-[14px]",
    },
    color: {
      primary: "text-v2-primary",
      secondary: "text-v2-secondary",
      error: "text-v2-action-negative",
    },
    fontWeight: {
      semibold: "font-semibold",
      medium: "font-medium",
      regular: "font-normal",
    },
  },
  defaultVariants: {
    variant: 300,
    color: "primary",
    fontWeight: "medium",
  },
});

type BodyProps = VariantProps<typeof bodyVariants> & {
  children: React.ReactNode;
  className?: string;
  onClick?(): void;
};

export const Body = ({
  variant,
  color,
  fontWeight,
  className,
  children,
  onClick,
}: BodyProps) => {
  return (
    <div
      className={twMerge(
        bodyVariants({ variant, color, fontWeight }),
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
